import { useDrop } from 'react-dnd';
import { useState } from 'react';
import { updateSingleProject } from '../../hooks/db';
import ProjectBlobNarrow from './ProjectBlobNarrow';
import { Link } from "react-router-dom";

const updateProject = async (updatedProject) => {

    try {
        await updateSingleProject(updatedProject.project_id, updatedProject);
    } catch (err) {
        console.error("Error updating project: ", err);
        return;
    } finally {
        console.log("Updating project...");
    }
}

const ProjectBasket = (props) => {

    const status = props.category.status;
    const category = props.category;
    const setProjects = props.setProjects;

    const filteredProjects = props.projects
        .filter(c => c.status == status)
        .map(c => (
            <Link
                to="/project"
                state={{ project_id: c.project_id }}
                key={c.project_id}
            >
                <ProjectBlobNarrow key={c.project_id} project={c} />
            </Link>
        ))
    //console.log('Filtered Projects:', props.projects);
    // const basket = props.projects.filter(
    //     project => project.status === status
    // );


    const [{ isOver }, dropRef] = useDrop({
        accept: 'project',
        drop: (item) => {
        console.log('Dropped item:', item);
            const updatedProject = item.project;
            updatedProject.status = category.status;
            updateProject(updatedProject); // 👈 add this
        setProjects(prev =>
            prev.map(project =>
            project.project_id === item.project_id
                ? { ...project, status }
                : project
            )
            );
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })
if (category.status != "Complete") {
return (
        <div
            key={category.status}
            ref={dropRef}
           className={`min-w-[300px] max-w-[475px] min-h-[100px] rounded-xl bg-[#181818]
                pt-2 pb-3 px-3 basket
                outline outline-dashed outline-2
                transition-[outline-color] duration-300 ease-in-out
                ${isOver ? "outline-yellow-500/50" : "outline-transparent"}
            `}
        >
            <h5 className="uppercase text-xs tracking-wider">{category.label}</h5>
            <div className="hBar mt-[2px] mb-[10px]" style={{ backgroundColor: category.color }}></div>
            <div className="flex flex-col gap-1"></div>

            {filteredProjects}
            {/* </div> */}
        </div>
)
} else {

    //filter paid projects from filteredProjects
    const paidProjects = filteredProjects.filter(project => {
        const paid = Number(project.props.children.props.project.paid.replace(/[$,]/g, '')) || 0;
        const fee = Number(project.props.children.props.project.fee.replace(/[$,]/g, '')) || 0;
        return paid >= fee;
    });
    const unPaidProjects = filteredProjects.filter(project => {
        //console.log('Project in Unpaid Filter:', Number(project.props.children.props.project.paid));
        const paid = Number(project.props.children.props.project.paid.replace(/[$,]/g, '')) || 0;
        const fee = Number(project.props.children.props.project.fee.replace(/[$,]/g, '')) || 0;
        // console.log('Paid:', paid, 'Fee:', fee);
        return paid < fee;
    });
        // console.log(unPaidProjects)
    return (
        <div
            key={category.status}
            ref={dropRef}
            className={`min-h-[100px] rounded-xl bg-[#181818]
                flex flex-col
                pt-2 pb-3 px-3 basket
                outline outline-dashed outline-2
                transition-[outline-color] duration-300 ease-in-out
                ${isOver ? "outline-yellow-500/50" : "outline-transparent"}
            `}
        >
            <h5 className="uppercase text-xs tracking-wider">{category.label}</h5>
            <div className="hBar mt-[2px] mb-[10px]" style={{ backgroundColor: category.color }}></div>
            <div className=" flex flex-row m-auto gap-3">
                <div className="min-w-[300px] max-w-[475px]">
                    <h5 className="uppercase text-xs tracking-wider">Unpaid</h5>
                    <div className="hBar mt-[2px] mb-[10px] bg-[#cccccc]"></div>

                    {unPaidProjects}
                </div>
                <div className="min-w-[300px] max-w-[475px]">
                    <h5 className="uppercase  text-xs tracking-wider">Recently Completed</h5>
                    <div className="hBar mt-[2px] mb-[10px] bg-[#cccccc]"></div>
                    {paidProjects}
                </div>
                </div>
                


        </div>
    )
    
}
}

export default ProjectBasket;